import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Mail, Check } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

const EmailCaptureSection = () => {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { toast } = useToast();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
      toast({
        title: "You're on the list!",
        description: "Watch your inbox for exclusive deals and updates.",
      });
      setEmail("");
      setTimeout(() => setIsSubmitted(false), 3000);
    }
  };

  return (
    <section className="py-24 bg-gradient-to-br from-sunset/20 via-golden/20 to-sand relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-sunset/20 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-golden/20 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative">
        <div className="max-w-2xl mx-auto text-center">
          {/* Icon */}
          <div className="w-16 h-16 rounded-2xl bg-sunset/20 flex items-center justify-center mx-auto mb-8">
            <Mail className="h-8 w-8 text-sunset" />
          </div>

          {/* Heading */}
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-brown mb-4">
            Get Exclusive Deals & Updates
          </h2>
          <p className="text-lg text-muted-foreground mb-8">
            Be the first to know about specials, events, and last-minute openings.
          </p>

          {/* Form */}
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto mb-4">
            <Input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="flex-1 h-12 bg-card border-border text-foreground"
            />
            <Button
              type="submit"
              variant="hero"
              size="lg"
              className="h-12"
              disabled={isSubmitted}
            >
              {isSubmitted ? (
                <>
                  <Check className="h-5 w-5" />
                  Subscribed!
                </>
              ) : (
                "Subscribe"
              )}
            </Button>
          </form>

          <p className="text-sm text-muted-foreground">
            We respect your inbox. Unsubscribe anytime.
          </p>
        </div>
      </div>
    </section>
  );
};

export default EmailCaptureSection;
